// extracted by mini-css-extract-plugin
module.exports = {"imageCopy":"_e621e2af","bannerImgContainer":"_6b538e9d","bannerImg":"_c82fcd3a","isFullBleed":"_71abc42e","carouselContainer":"_6539ed7a"};